import { ref } from '@vue/composition-api'
import CustomerApi from '@/api/waiter/Customer'
import { handleApiError } from '@/utils/errorHandler'

export const RANKING_TYPES = [
  { value: 'sales', text: '売上金額' },
  { value: 'visits', text: '来店回数' },
]

export const LIMIT_OPTIONS = [
  { value: 10, text: 'TOP 10' },
  { value: 20, text: 'TOP 20' },
  { value: 50, text: 'TOP 50' },
]

export default function useCustomerRanking(vm) {
  const ranking = ref([])
  const loading = ref(false)
  const type = ref('sales')
  const limit = ref(10)
  const period = ref({ startDate: null, endDate: null })

  const fetchRanking = async ({
    rankingType = 'sales',
    rankingLimit = 10,
    startDate = null,
    endDate = null,
  } = {}) => {
    loading.value = true
    try {
      const res = await CustomerApi.getRanking({
        type: rankingType,
        limit: rankingLimit,
        startDate,
        endDate,
      })

      type.value = res.data.type
      limit.value = res.data.limit
      period.value = res.data.period || {}
      ranking.value = res.data.ranking || []

      return ranking.value
    } catch (error) {
      handleApiError(error, { $toast: vm.$toast })

      return []
    } finally {
      loading.value = false
    }
  }

  const getTypeLabel = typeValue => {
    const found = RANKING_TYPES.find(t => t.value === typeValue)

    return found ? found.text : typeValue
  }

  return {
    ranking,
    loading,
    type,
    limit,
    period,
    fetchRanking,
    getTypeLabel,
    RANKING_TYPES,
    LIMIT_OPTIONS,
  }
}
